import React, { useState, useEffect } from 'react';
import Checkbox from '@/UIlibrary/Checkbox/Checkbox';
import { COLOR_TYPE } from '@/UIlibrary/globalTypes';
import { Typography } from '@/UIlibrary/Typography/Typography';

export interface CheckboxOption {
	value: string;
	label?: string;
}

interface CheckboxGroupProps {
	options: CheckboxOption[];
	value?: string;
	onChange: (value: string) => void;
	name: string;
	label?: string;
	disabled?: boolean;
	type?: COLOR_TYPE;
	iconType?: 'check' | 'select';
	customCheckboxStyles?: string;
	checkboxStyle?: 'rounded' | 'default';
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
	options,
	value,
	onChange,
	name,
	label,
	disabled = false,
	type = 'primary',
	iconType = 'check',
	customCheckboxStyles = '',
	checkboxStyle = 'default'
}) => {
	const [selectedValue, setSelectedValue] = useState<string | undefined>(value);

	useEffect(() => {
		setSelectedValue(value);
	}, [value]);

	const handleCheckboxChange = (optionValue: string) => {
		const newValue = optionValue === selectedValue ? undefined : optionValue;
		setSelectedValue(newValue);
		onChange(newValue || '');
	};

	return (
		<>
			{label && (
				<Typography size="md" weight="semibold">
					{label}
				</Typography>
			)}
			{options.map((option) => (
				<div
					className={`${customCheckboxStyles} print:flex print:items-center print:justify-center`}
					key={option.value}
				>
					<Checkbox
						key={option.value}
						name={`${name}-${option.value}`}
						label={option.label || ''}
						checked={selectedValue === option.value}
						onChange={() => handleCheckboxChange(option.value)}
						disabled={disabled}
						type={type}
						iconType={iconType}
						rounded={checkboxStyle === 'rounded'}
					/>
				</div>
			))}
		</>
	);
};

export default CheckboxGroup;
